
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminals",
      function () {
        return require("private-next-pages/terminals.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminals"])
      });
    }
  